import { Box, Button, Heading } from '@zillow/constellation-10';
import { IconChevronDownFilled } from '@zillow/constellation-icons';
import RentalJourneyFiltersSkeleton from '../RentalJourneyFilters/skeleton';
import FiltersSelectorSkeleton from '../FiltersSelector/skeleton';
import {
  filtersSelectorContainerStyles,
  foldersSelectorContainerStyles,
  headerContainerStyles,
  headingStyles,
  rentalJourneyFiltersContainerStyles,
} from './styles';

export default function InboxHeaderSkeleton(): JSX.Element {
  return (
    <Box css={headerContainerStyles}>
      <Heading level={1} fontFamily="heading-alt" css={headingStyles}>
        Messages
      </Heading>

      <Box css={rentalJourneyFiltersContainerStyles}>
        <RentalJourneyFiltersSkeleton />
      </Box>

      <Box css={filtersSelectorContainerStyles}>
        <FiltersSelectorSkeleton />
      </Box>

      <Box css={foldersSelectorContainerStyles}>
        <Button emphasis="outlined" icon={<IconChevronDownFilled />} iconPosition="end" size="md" tone="brand">
          Inbox
        </Button>
      </Box>
    </Box>
  );
}
